var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRefresh = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06928 3.125C10.5887 3.125 12.0278 3.62153 13.2172 4.52521L10.4641 7.11708L17.4667 7.86799L17.1375 0.833333L14.3455 3.46264C12.8559 2.25569 11.0134 1.59722 9.06928 1.59722C4.4363 1.59722 0.666504 5.36701 0.666504 10H2.19428C2.19428 6.20882 5.2781 3.125 9.06928 3.125Z",
    fill: "#5C5F62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06882 16.875C7.54944 16.875 6.11028 16.3785 4.9209 15.4748L7.67396 12.8829L0.671387 12.132L1.00062 19.1667L3.79264 16.5374C5.28222 17.7443 7.12472 18.4028 9.06882 18.4028C13.7018 18.4028 17.4716 14.633 17.4716 10H15.9438C15.9438 13.7912 12.86 16.875 9.06882 16.875Z",
    fill: "#5C5F62"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRefresh, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/refresh.c4d01b8f.svg";
export { ForwardRef as ReactComponent };